import { Dispatch, SetStateAction, useEffect, useState } from 'react';

function appendScript(baseUrl: string, setScriptLoaded: Dispatch<SetStateAction<boolean>>) {
  if (window.MktoForms2) return setScriptLoaded(true);

  const script = document.createElement('script');
  script.src = `${baseUrl}/js/forms2/js/forms2.min.js`;
  script.onload = () => (window.MktoForms2 ? setScriptLoaded(true) : null);
  document.body.appendChild(script);
}

export const useMarketo = (baseUrl: string, munchkinId: string, formId: number) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    if (scriptLoaded) {
      const script = document.createElement('script');
      script.appendChild(
        document.createTextNode(`MktoForms2.loadForm('${baseUrl}', '${munchkinId}', ${formId}, function(form) {
        form.onSuccess(function(values, followUpUrl) {
            window.parent.location.href = "https://www.dataset.com/trial-thank-you/";
            return false;
        });
    });`),
      );
      document.body.appendChild(script);
      return;
    }
    appendScript(baseUrl, setScriptLoaded);
  }, [scriptLoaded]);

  return scriptLoaded;
};
